import { render, staticRenderFns } from "./PatientInformationTab.vue?vue&type=template&id=536e03ec"
import script from "./PatientInformationTab.vue?vue&type=script&lang=js"
export * from "./PatientInformationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports